export default {
    CHANGE: '@__change_books_data',
};
